import React, { memo } from 'react';

type TermsOfServiceContentProps = { content: string };

const TermsOfServiceContent = memo(
  ({ content }: TermsOfServiceContentProps): JSX.Element => <div dangerouslySetInnerHTML={{ __html: content }}></div>
);

export default TermsOfServiceContent;
